// The welcome page. Imports `api` and NOTHING ELSE — in particular not maplibre-gl, whose
// ~1 MB has to be parsed and executed before any script on its page can run. That cost is why
// the sign-in form used to be unresponsive for many seconds on an older machine, and no amount
// of deferring the map CALL could avoid it: the import happens at parse time.
//
// Signing in is a different job from scouting, so it is a different page.
import { ApiError, emailStart, emailVerify, token } from "./api";
import "./welcome.css";

const $ = <T extends HTMLElement>(id: string) => document.getElementById(id) as T;
const MAP = "/app/map.html";

const form = $<HTMLFormElement>("signin");
const input = $<HTMLInputElement>("email");
const button = $<HTMLButtonElement>("go");
const err = document.querySelector<HTMLElement>(".err")!;

// Already signed in: offer the desk rather than asking again, but never redirect out from
// under someone who deliberately came here.
if (token()) {
  form.replaceChildren(Object.assign(document.createElement("a"), {
    className: "btn-primary", href: MAP, textContent: "Open the scouting desk →",
  }));
}

let email = "";
let step: "email" | "code" = "email";

function explain(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.status === 404) return "Sign-in isn't switched on for this server yet.";
    if (e.status === 429) return e.retryAfter ? `Too many tries — wait ${e.retryAfter}s.` : e.message;
    return e.message;
  }
  return "Couldn't reach the server.";
}

form.addEventListener("submit", async (ev) => {
  ev.preventDefault();
  const value = input.value.trim();
  if (!value) { input.focus(); return; }
  button.disabled = true;
  err.textContent = "";
  try {
    if (step === "email") {
      await emailStart(value);
      email = value;
      step = "code";
      // Same field, re-labelled: one input is less to look at than a second screen.
      input.type = "text";
      input.inputMode = "numeric";
      input.autocomplete = "one-time-code";
      input.value = "";
      input.placeholder = "6-digit code";
      input.maxLength = 7;
      button.textContent = "Sign in";
      document.querySelector("label")!.textContent = `Enter the code sent to ${email}.`;
      input.focus();
    } else {
      await emailVerify(email, value);
      location.href = MAP;                    // straight to the desk
      return;
    }
  } catch (e) {
    err.textContent = explain(e);
  }
  button.disabled = false;
});
